/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    greyButton: { 
        ...theme.custom.elements.greyButton
    }
}));

export interface ButtonProps {
    id?: string,
    onClick?: () => void,
    text?: string;
    className?: string;
    startIcon?: React.ReactNode;
    disabled?: boolean;
}

function GreyOutlinedButton(props: ButtonProps) {
    const classes = useStyles();
    const { id, className, startIcon, disabled, text, onClick } = props;
    return (
        <Button
            variant="contained"
            disableElevation={true}
            classes={{root: classes.greyButton}}
            className={className}
            onClick={onClick}
            startIcon={startIcon}
            disabled={disabled}
            data-testid={id}
            disableRipple={true}
            disableTouchRipple={true}
        >
            {text}
        </Button>
    );
}

export default GreyOutlinedButton;
